'use strict'

const get_ = require('lodash/get')
const actionReducerCreator = require('dbsm-common/src/actionReducer')
const defaultDatasetConfiguration = require('dbsm-common/src/dataset-configuration/defaults')
const readWriteModes = require('dbsm-common/src/dataset-configuration/readWriteModes')
const actionTypes = require('./actionTypes')
const rootActions = require('../dataset-controller/actions')

const initialState = defaultDatasetConfiguration

module.exports = actionReducerCreator(
  initialState,
  new class {
    [rootActions.actionTypes.SET_CONTROLLER_CONFIG](state, action) {
      return Object.assign(
        {},
        state,
        defaultDatasetConfiguration,
        { isDuringSave: false, isDatasetReady: false },
        action.config
      )
    }
    [actionTypes.SET_FILTER](state, action) {
      const { filter } = action

      return Object.assign({}, state, { filter })
    }
    [actionTypes.SET_SORT](state, action) {
      const { sort } = action

      return Object.assign({}, state, { sort })
    }
    [actionTypes.SET_IS_DURING_SAVE](state, action) {
      const { isDuringSave } = action

      return Object.assign({}, state, { isDuringSave })
    }
    [actionTypes.SET_IS_DATASET_READY](state, action) {
      const { isDatasetReady } = action

      return Object.assign({}, state, { isDatasetReady })
    }
    [actionTypes.SET_FIXED_FILTER_ITEM](state, action) {
      const { fixedFilterItem } = action

      return Object.assign({}, state, { fixedFilterItem })
    }
  }()
)

module.exports.getConfig = state => state

module.exports.isWriteOnly = state =>
  state.readWriteType === readWriteModes.WRITE

module.exports.isReadOnly = state => state.readWriteType === readWriteModes.READ

module.exports.getReadWriteMode = state => state.readWriteType

module.exports.isDuringSave = state => state.isDuringSave

module.exports.isDatasetReady = state => state.isDatasetReady

module.exports.isDatasetConfigured = state => !!get_(state, 'collectionName')

module.exports.getPageSize = state => state.pageSize

module.exports.getFixedFilterItem = state => state.fixedFilterItem

module.exports.getCollectionName = state => state.collectionName



// WEBPACK FOOTER //
// ./dataset-config/reducer.js